module.exports = __webpack_public_path__ + "static/Rubik-Regular-5d278b91b774c76dae5d47a9f318d737.woff";